export const cloudinaryConfig = {
  cloudName: 'dnshc7zfr',
  uploadPreset: 'landing_page_images',
};
